import { inject, Injectable } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { PageActionStateService } from "app/core/store/page-action/page-action.state.service";
import { ErreurService } from "app/main/authentification/erreur.service";
import { SuccesSnakBarComponent } from "app/main/components/succes-snak-bar/succes-snak-bar.component";
import { VehiculeComponent } from "app/main/plus/ressources/vehicule/vehicule.component";
import { VehiculeService } from "app/main/plus/ressources/vehicule/vehicule.service";

@Injectable({
  providedIn: "root",
})
export class VehiculleService {
  private dialog = inject(MatDialog); // Assuming you have MatDialog injected in your constructor

  private addservice = inject(VehiculeService);

  private snackBar = inject(MatSnackBar);

  private errService = inject(ErreurService); // Assuming you have ErrorService injected in your constructor

  private _pageActionStateService = inject(PageActionStateService);

  addVehicule(): void {
    const dialogRef = this.dialog.open(VehiculeComponent, {
      panelClass: "common-dialog-style",
      width: "auto",
      data: {
        action: "new",
      },

    });

    dialogRef.afterClosed().subscribe((response) => {
      if (response) {
        let type = "";
        for (let i = 0; i < response.type.length; i++) {
          if (i === 0) {
            type = response.type[i];
          } else {
            type += "/" + response.type[i];
          }
        }
        response.type = type;
        this.addservice.addVehicule(response).subscribe(
          () => {
            if (response) {
              this.snackBar.openFromComponent(
                SuccesSnakBarComponent,
                {
                  duration: 3000,
                },
              );
              this._pageActionStateService.setFetchData('vehicule');
            }
          },
          (err) =>
            this.errService.popError(
              err,
              "Erreur s'est produit lors d'ajout de véhicule. \n Essayez plus tard.'",
            ),
        );
      }
    });
  }
}
